import React, { useState } from "react";
import * as Style from "../styledComponents/AudioVideo";
import { Modal } from "antd";
import img1 from "../../assets/images/DeathModuleNew/leftcr1.png";
import img2 from "../../assets/images/DeathModuleNew/leftcr2.jpg";
import img3 from "../../assets/images/DeathModuleNew/leftcr3.png";
import img4 from "../../assets/images/DeathModuleNew/leftcr4.png";
import img5 from "../../assets/images/DeathModuleNew/leftcr5.png";
import img6 from "../../assets/images/DeathModuleNew/leftcr6.png";
import img7 from "../../assets/images/DeathModuleNew/leftcr7.jpg";
import img8 from "../../assets/images/DeathModuleNew/leftcr8.png";
import img9 from "../../assets/images/DeathModuleNew/leftcr9.png";
import img10 from "../../assets/images/DeathModuleNew/leftcr10.png";
import "./thirdParty.css";

export const ThirdPartyResource = () => {
  const imageList = [
    {
      id: 1,
      fileName: img1,
      name: "Online Remote Therapy",
      href: "https://www.talkspace.com/",
      coupen: "xyz",
      discount: "20%",
    },
    {
      id: 2,
      fileName: img2,
      name: "Online Therapy",
      href: "https://www.betterhelp.com/ ",
      coupen: "xyz",
      discount: "20%",
    },
    {
      id: 3,
      fileName: img3,
      name: "Personal Psychology and Therapy",
      href: "https://www.psychologytoday.com/us/therapists/91361?category=online-counseling",
      coupen: "xyz",
      discount: "20%",
    },
    {
      id: 4,
      name: "Online Therapy Insurance Focused",
      fileName: img4,
      href: "https://www.teladoc.com/",
      coupen: "xyz",
      discount: "20%",
    },
  ];
  const imageList1 = [
    {
      id: 1,
      fileName: img5,
      name: "Healing Through Crafts",
      href: "https://www.pinterest.com/healingbrave/  ",
      coupen: "xyz",
      discount: "20%",
    },
    {
      id: 2,
      fileName: img10,
      name: "Famous People Delivering Custom Messages",
      href: "https://www.cameo.com/",
      coupen: "xyz",
      discount: "20%",
    },
    {
      id: 3,
      fileName: img6,
      name: "Words of Faithful Healing",
      href: "https://christian.net/resources/bible-verses-about-grief/",
      coupen: "xyz",
      discount: "20%",
    },

    {
      id: 4,
      fileName: img7,
      name: "Resources for Jewish Mourning",
      href: "https://www.shiva.com/learning-center/resources/poems-of-comfort",
      coupen: "xyz",
      discount: "20%",
    },
    {
      id: 5,
      name: "A Place of Communal Support",
      fileName: img8,
      href: "https://www.griefshare.org/ ",
      coupen: "xyz",
      discount: "20%",
    },
    {
      id: 6,
      fileName: img9,
      name: "Amazon Books on Grief",
      href: "https://www.amazon.com/Grief-Bereavement-Death-Books/b?ie=UTF8&node=4610",
      coupen: "xyz",
      discount: "20%",
    },
  ];
  const [tooltipModal, setTooltipModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [clickedItem, setClickedItem] = useState(null);
  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
    setIsChecked(false);
    setClickedItem(null);
  };
  const handleTooltipOk = () => {
    setTooltipModal(false);
    if (isChecked) {
      window.open(clickedItem.href, "blank");
    }
    setIsChecked(false);
    setClickedItem(null);
  };
  return (
    <div>
      <div className="MainSec">
        <div className="flexcard">
          <h1 className="MainCardsHeading">Professional Resources</h1>
          {imageList &&
            imageList.map((item, index) => (
              <div key={index} className="Adscard">
                <img
                  src={item.fileName}
                  width={175}
                  height={110}
                  style={{ cursor: "pointer" }}
                  alt="image"
                  onClick={() => {
                    showTooltipModal();
                    setClickedItem(item);
                  }}
                />
                <div className="AdscardHead">{item.name}</div>
                <div>
                  Coupon Code:{" "}
                  <span style={{ color: "#2A3DA3" }}>{item.coupen}</span>
                </div>
                <div>
                  Use coupon to save upto{" "}
                  <span style={{ color: "#2A3DA3" }}>{item.discount}</span>
                </div>
              </div>
            ))}{" "}
        </div>
        <div className="flexcard">
          <h1 className="MainCardsHeading">Self-Help Resources</h1>
          {imageList1 &&
            imageList1.map((item, index) => (
              <div key={index} className="Adscard">
                <img
                  src={item.fileName}
                  width={175}
                  height={110}
                  alt="image"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    showTooltipModal();
                    setClickedItem(item);
                  }}
                />
                <div className="AdscardHead">{item.name}</div>
                <div>
                  Coupon Code:{" "}
                  <span style={{ color: "#2A3DA3" }}>{item.coupen}</span>
                </div>
                <div>
                  Use coupon to save upto{" "}
                  <span style={{ color: "#2A3DA3" }}>{item.discount}</span>
                </div>
              </div>
            ))}
        </div>
      </div>
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}
      >
        <Style.ModalTitle> Third-Party Disclaimer</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              <p>
                <strong style={{fontSize:"15px"}}>Third-Party Disclaimer; </strong>This website may
                contain links to third-party websites. Asset Planet is not
                responsible for the content, accuracy, or privacy practices of
                any third-party website. When you click on a link to a
                third-party website, you are leaving our website and entering
                the third-party website at your own risk. We encourage you to
                review the privacy policy of any third-party website before you
                provide them with any personal information.
                <br />
                <br />
                <strong style={{fontSize:"15px"}}>Disclaimer of Liability; </strong> We make no
                representations or warranties of any kind, express or implied,
                as to the operation of this website or the information, content,
                materials, or products included on this website. To the fullest
                extent permitted by law, we disclaim all liability for any
                damages of any kind, including direct, indirect, incidental,
                punitive, and consequential damages, arising out of or in
                connection with your access to or use of this website.
                <br />
                <br />
                <strong style={{fontSize:"15px"}}>
                  Compensation; if Asset Planet receives any 3rdd party discount
                  we pass it along to our members. If Asset Planet receives a
                  commission from 3rd party due to our members purchasing some
                  item of their choosing, then our members will receive rewards
                  points. The points shall be calculated at a rate of no less
                  than 50% cash value at the time of initial transaction
                  completion. Points can be redeemed against annual renewals,
                  special promotions, in-app upgrades, and other items
                  available, and subject to change.{" "}
                </strong>
                <br />
                <br />
                <label class="container1">
                  <input
                    type="checkbox"
                    id="check"
                    name="check"
                    value="yes"
                    checked={isChecked}
                    onChange={handleOnChange}
                  />
                  <span class="checkmark"></span>
                  You agree to hold us harmless from and against any and all
                  claims, losses, damages, and expenses (including reasonable
                  attorneys' fees) arising out of or in connection with your use
                  of this website.
                </label>
              </p>
            </Style.ModalDetails>
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent:"center" }}>
            <Style.CancelButton
            disabled={!isChecked}
              onClick={() => {
                handleTooltipOk();
              }}
            >
              Confirm
            </Style.CancelButton>
          </div>
        </div>
      </Modal>
    </div>
  );
};
